import Client1 from '../../assets/image/saas/testimonial/client-1.jpg';
import Client2 from '../../assets/image/agency/client/denny.png';

import Calendar from "../../assets/image/saas/calendar.png";
import Search from "../../assets/image/saas/search.png";
import Gem from "../../assets/image/saas/gem.png";
import Wink from "../../assets/image/saas/wink.png";
import Notes from "../../assets/image/saas/notes.png";

export const Faq = [
  {
    id: 1,
    title: 'S\'agit-il d\'une solution plug and play que je ne pourrai pas modifier ?',
    description:
      'Pas du tout ! Voyez-la plutôt comme un boite à outil et une méthodologie bien rodée, nous permettant d’aller vite. Très vite. N’oublions pas que chaque client est unique !',
  },
 {
   
    id: 2,
    expend: true,
    title: 'Mais une telle solution doit couter cher…',
    description:
      'Pas d\'inquiétude, grâce à la PowerPlatform, la 1ère version de votre application peut être disponible en 5 jours.',
  },
  {
    id: 3,
    title: 'Et si je veux faire évoluer ma solution dans le futur ?',
    description:
      'Vous pouvez le faire vous même et on peut vous aidera à le faire. Ou on peut s\'en occuper pour vous.',
  },
  {
    id: 4,
    title: 'Quelles sont les prérequis ?',
    description:
      'Il y en a peu, mais avoir O365 et un accès API à quelques datas est un plus.',
  },
  {
    id: 5,
    title: 'Et pour garantir l\'adoption ?',
    description:
      'On s’en occupe ! Chez Twelve, nous sommes LES spécialistes de l\'adoption.',
  },
  {
    id: 6,
    title: 'Quels sont les secteur couverts ? ',
    description:
      'Tous les secteurs le sont, particulièrement banque / assurance / santé, nos secteurs de prédilection.',
  },
  {
    id: 7,
    title: 'Je ne fais pas de RDV. D\'autres usages pour PowerApps ? ',
    description:
      'Yes ! Nous avons plein d\'idées autour de l\'adoption, des jeux digitaux, des apps métiers, des murs digitaux etc.' ,
  }
];

export const Features = [
  {
    id: 1,
    icon: 'flaticon-creative',
    title: 'Powerful Features',
    description:
      'Automate time consuming tasks like organising expenses ,tracking your time and following up with clients ',
  },
  {
    id: 2,
    icon: 'flaticon-briefing',
    title: 'Easy Invoicing',
    description:
      'Want to surprice your clients with professional looking invoices ? Then you are some clicks behind .',
  },
  {
    id: 3,
    icon: 'flaticon-flask',
    title: 'Easy To Use',
    description:
      'Very Simple and intuitive. So you have to spend less time in paperwork and impress your customer with looks',
  },
];

export const Footer_Data = [
  {
    title: 'À Propos',
    menuItems: [
      {
        url: 'https://www.twelve-consulting.com',
        text: 'Twelve Consulting',
      },
      {
        url: 'https://www.twelve-consulting.com/clients/',
        text: 'Nos clients',
      },
    ],
  }
];

export const Service = [
  {
    id: 1,
    icon: 'flaticon-briefing',
    title: 'App Development',
    description:
      'We are specialized at custom Saas Application Development and special features .',
  },
  {
    id: 2,
    icon: 'flaticon-trophy',
    title: '10 Times Award',
    description:
      'We are globally recognised for our services and won a lot of prices around the world .',
  },
  {
    id: 3,
    icon: 'flaticon-atom',
    title: 'Cloud Stroage',
    description:
      'LiteSpeed Web Server known for its high performance and low resource consumption.',
  },
  {
    id: 4,
    icon: 'flaticon-ruler',
    title: 'Client Satisfaction',
    description:
      'Client Satisfaction is our first priority and We are best at it .Keep In Touch.',
  },
  {
    id: 5,
    icon: 'flaticon-creative',
    title: 'UX Planning',
    description:
      'We provide the best UI/UX Design by following the latest trends of the market  .',
  },
  {
    id: 6,
    icon: 'flaticon-conversation',
    title: 'Customer Support',
    description:
      'A Dedicated support team is always ready to provide best support to our customers.',
  },
];

export const Timeline = [
  {
    title: 'Préparer',
    description:
      "Grâce à un accès rapide aux informations du client, définissez simplement l'odre du jour de votre rendez-vous.",
  },
  {
    title: 'Animer',
    description:
      'Tout en répondant aux questions de votre client, faites évoluer la présentation sans interrompre le fil de votre rendez-vous.',
  },
  {
    title: 'Partager',
    description:
      "Retrouvez l'ensemble du contenu de vos échanges, et communiquez les prochaines étapes en 3 clics avec vos collaborateurs.",
  },
];

export const Testimonial = [
  {
    id: 1,
    name: 'Michal Andry',
    designation: 'Ceo of Invission Co.',
    comment:
      'Love to work with this designer in every our future project to ensure we are going to build best prototyping features.',
    avatar_url: Client1,
    social_icon: 'flaticon-instagram',
  },
  {
    id: 2,
    name: 'Roman Ul Oman',
    designation: 'Co-founder of QatarDiaries',
    comment:
      'Impressed with master class support of the team and really look forward for the future. A true passionate team.',
    avatar_url: Client2,
    social_icon: 'flaticon-twitter-logo-silhouette',
  },
];

export const MENU_ITEMS = [
  {
    label: 'Accueil',
    path: '#banner_section',
    offset: '70',
  },
  {
    label: 'Présentation',
    path: '#service_section',
    offset: '70',
  },
  {
    label: 'Usages',
    path: '#timeline_section',
    offset: '70',
  },
  {
    label: 'Intégrations',
    path: '#integration_section',
    offset: '70',
  },
  {
    label: 'FAQ',
    path: '#faq_section',
    offset: '70',
  },
];

export const MONTHLY_PRICING_TABLE = [
  {
    freePlan: true,
    name: 'Basic Account',
    description: 'For Small teams or group who need to build website ',
    price: '$0',
    priceLabel: 'Only for first month',
    buttonLabel: 'CREATE FREE ACCOUNT',
    url: '#',
    listItems: [
      {
        content: 'Drag & Drop Builder',
      },
      {
        content: '1,000s of Templates Ready',
      },
      {
        content: 'Blog Tools',
      },
      {
        content: 'eCommerce Store ',
      },
      {
        content: '30+ Webmaster Tools',
      },
    ],
  },
  {
    name: 'Business Account',
    description: 'For Mediums teams or group who need to build website ',
    price: '$9.87',
    priceLabel: 'Per month & subscription yearly',
    buttonLabel: 'START FREE TRIAL',
    url: '#',
    listItems: [
      {
        content: 'Drag & Drop Builder',
      },
      {
        content: '1,000s of Templates Ready',
      },
      {
        content: 'Blog Tools',
      },
      {
        content: 'eCommerce Store ',
      },
      {
        content: '30+ Webmaster Tools',
      },
    ],
  },
  {
    name: 'Premium Account',
    description: 'For Large teams or group who need to build website ',
    price: '$12.98',
    priceLabel: 'Per month & subscription yearly',
    buttonLabel: 'START FREE TRIAL',
    url: '#',
    listItems: [
      {
        content: 'Drag & Drop Builder',
      },
      {
        content: '1,000s of Templates Ready',
      },
      {
        content: 'Blog Tools',
      },
      {
        content: 'eCommerce Store ',
      },
      {
        content: '30+ Webmaster Tools',
      },
    ],
  },
];

export const YEARLY_PRICING_TABLE = [
  {
    freePlan: true,
    name: 'Basic Account',
    description: 'For a single client or team who need to build website ',
    price: '$0',
    priceLabel: 'Only for first month',
    buttonLabel: 'CREATE FREE ACCOUNT',
    url: '#',
    listItems: [
      {
        content: 'Drag & Drop Builder',
      },
      {
        content: '1,000s of Templates Ready',
      },
      {
        content: 'Blog Tools',
      },
      {
        content: 'eCommerce Store ',
      },
      {
        content: '30+ Webmaster Tools',
      },
    ],
  },
  {
    name: 'Business Account',
    description: 'For Small teams or group who need to build website ',
    price: '$6.00',
    priceLabel: 'Per month & subscription yearly',
    buttonLabel: 'START FREE TRIAL',
    url: '#',
    listItems: [
      {
        content: 'Unlimited secure storage',
      },
      {
        content: '2,000s of Templates Ready',
      },
      {
        content: 'Blog Tools',
      },
      {
        content: '24/7 phone support',
      },
      {
        content: '50+ Webmaster Tools',
      },
    ],
  },
  {
    name: 'Premium Account',
    description: 'For Large teams or group who need to build website ',
    price: '$9.99',
    priceLabel: 'Per month & subscription yearly',
    buttonLabel: 'START FREE TRIAL',
    url: '#',
    listItems: [
      {
        content: 'Drag & Drop Builder',
      },
      {
        content: '3,000s of Templates Ready',
      },
      {
        content: 'Advanced branding',
      },
      {
        content: 'Knowledge base support',
      },
      {
        content: '80+ Webmaster Tools',
      },
    ],
  },
];

export const SERVICE_FEATURES_ITEMS = [
  {
    icon: Calendar,
    title: "Animez vos rendez-vous"
  },
  {
    icon: Search,
    title: "Présentez votre offre"
  },
  {
    icon: Notes,
    title: "Prenez des notes"
  },
  {
    icon: Gem,
    title: "Proposez les bons produits"
  },
  {
    icon: Wink,
    title: "Simplifiez les actes de gestion"
  }
];